import { render, staticRenderFns } from "./YkbReport.vue?vue&type=template&id=0ffbe7c9&"
import script from "./YkbReport.vue?vue&type=script&lang=js&"
export * from "./YkbReport.vue?vue&type=script&lang=js&"
import style0 from "./YkbReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports